import {
	BetweenHorizonalEnd,
	BetweenHorizonalStart,
	BetweenVerticalEnd,
	BetweenVerticalStart,
	Bold,
	BookMarked,
	ChevronDown,
	ChevronsUpDown,
	Clipboard,
	Code,
	CodeXml,
	Columns2,
	Columns3,
	Columns4,
	Copy,
	Eraser,
	Eye,
	Frame,
	GripVertical,
	Heading1,
	Heading2,
	Heading3,
	Heading4,
	Heading5,
	Heading6,
	ImageUp,
	IndentDecrease,
	IndentIncrease,
	Italic,
	Link,
	List,
	ListOrdered,
	ListTodo,
	LoaderCircle,
	Maximize,
	Minimize,
	Minus,
	PaintRoller,
	PanelLeft,
	PanelRight,
	Pencil,
	Plus,
	Quote,
	Redo2,
	Replace,
	Settings,
	SmilePlus,
	SmilePlusIcon,
	Sparkles,
	Strikethrough,
	Subscript,
	Superscript,
	Table,
	TableCellsMerge,
	TableCellsSplit,
	Trash,
	Trash2,
	Type,
	Underline,
	Undo2,
	Unlink,
	Video,
	ZoomIn,
	ZoomOut
} from "lucide-react";
import {
	TextAlignCenterIcon,
	TextAlignJustifyIcon,
	TextAlignLeftIcon,
	TextAlignRightIcon
} from "@radix-ui/react-icons";
import ImportWord from "./ImportWord";
import {
	AspectRatio,
	BlockquoteLeft,
	DeleteColumn,
	DeleteRow,
	FileWordOutline,
	FormatLineHeight,
	MenuDown,
	SizeL,
	SizeM,
	SizeS
} from "../../components/icons";
import { ExportPdf } from "../../components/icons/ExportPdf";
import ExportWord from "../../components/icons/ExportWord";
import { ColumnAddLeft } from "../../components/icons/ColumnAddLeft";
import { ColumnAddRight } from "../../components/icons/ColumnAddRight";

export const icons = {
	Bold,
	LoaderCircle,
	Italic,
	Underline,
	Quote,
	TextQuote: BlockquoteLeft,
	Strikethrough,
	Minus,
	Eraser,
	PaintRoller,
	Redo2,
	Undo2,
	AlignCenter: TextAlignCenterIcon,
	AlignJustify: TextAlignJustifyIcon,
	AlignLeft: TextAlignLeftIcon,
	AlignRight: TextAlignRightIcon,
	ChevronDown,
	Subscript,
	Superscript,
	Code,
	Code2: CodeXml,
	Type,
	IndentIncrease,
	IndentDecrease,
	List,
	ListOrdered,
	ListTodo,
	Link,
	ImageUp,
	Video,
	Maximize,
	Minimize,
	Table,
	Sparkles,
	Pencil,
	Unlink,
	BetweenHorizonalEnd,
	BetweenHorizonalStart,
	BetweenVerticalStart,
	BetweenVerticalEnd,
	TableCellsMerge,
	TableCellsSplit,
	Trash2,
	Trash,
	Replace,
	ChevronsUpDown,
	LineHeight: FormatLineHeight,
	Word: FileWordOutline,
	Heading1,
	Heading2,
	Heading3,
	Heading4,
	Heading5,
	Heading6,
	Columns2,
	Columns3,
	Columns4,
	Plus,
	Grip: GripVertical,
	Copy,
	Clipboard,
	PanelLeft,
	PanelRight,
	Columns: Columns2,
	Iframe: Frame,
	MenuDown,
	SizeS,
	SizeM,
	SizeL,
	AspectRatio,
	Emoji: SmilePlus,
	DeleteColumn,
	DeleteRow,
	SearchAndReplace: Replace,
	EmojiIcon: SmilePlusIcon,
	ExportPdf,
	ExportWord,
	ImportWord,
	ColumnAddLeft,
	ColumnAddRight,
	BookMarked,
	ZoomIn,
	ZoomOut,
	Settings,
	Eye
};
